import axios from 'axios'
import { IhLogUrl, ihLive,ihMedia } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

/**
 * 标记重要视频
 */
export function isImportantFlag(params) {
  const url = IhLogUrl + '/medias/isImportantFlag'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '标记重要视频', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 查询视频信息
 */
export function videoInfo(params) {
  const url = IhLogUrl + '/videoInfo'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询视频信息', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 保存视频code信息
 */

export function mediasSaveCode(params) {
  const url = IhLogUrl + '/medias/save/code'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '保存视频code信息', res)
    }
    return Promise.resolve(res.data)
  })
}
export function hwssMedia(params, token, reqCode, reqTime, sign) {
  const url = ihLive + '/hwss/media'
  // console.log('params:', typeof(params),token,reqCode,reqTime,sign)
  return axios({
    headers: {
      token: token,
      'req-code': reqCode,
      'req-time': reqTime,
      sign: sign,
    },
    method: 'post',
    url: url,
    data: params,
    contentType: 'application/json',
    async: false,
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('实时监控', 'hwssMedia', res)
    }
    return Promise.resolve(res.data)
  })
}

export function apiMedia(params, token, reqCode, reqTime, sign) {
  const url = ihMedia + '/media'

  return axios({
    headers: {
      token: token,
      'req-code': reqCode,
      'req-time': reqTime,
      sign: sign,
    },
    method: 'post',
    url: url,
    data: params,
    contentType: 'application/json',
    async: false,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', 'hwssMedia', res)
    }
    return Promise.resolve(res.data)
  })
}
